import axios from 'axios';
import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import LeftNavbar from '../../components/LeftNavbar';
import TopHeader from '../../components/TopHeader';
import DragDropMultiple from '../../components/DragDropMultiple';
import { useEffect } from 'react';
import { Button, Col, Row, Form } from 'react-bootstrap';
import Select from 'react-select';
import { useParams, useLocation } from 'react-router-dom';
import { BASE_URL } from '../../components/App';
import { enrollmentInitiationFormValidation } from '../../helpers/validation';
import { MonaRoles } from '../../constant';
import moment from 'moment';
import { CHILDREN_CATEGORIES } from '../../constants/documentCategories';

const EditChildEnrollmentInitiation = ({ nextStep, handleFormData }) => {
  const LSToken = localStorage.getItem('token');
  const AxiosHeaders = { headers: { Authorization: `Bearer ${LSToken}` } }
  const [LSUserRole, setLSUserRole] = useState(localStorage.getItem("user_role"));
  let { childId: paramsChildId, parentId: paramsParentId } = useParams();
  let location = useLocation();
  let { state: payload } = location;
  const isViewOnly = location.pathname.includes('/view/');

  const [formOneChildData, setFormOneChildData] = useState({
    fullname: '',
    family_name: '',
    dob: '',
    home_address: '',
    gender: 'M',
    educator: [],
  });
  const [documentCategory, setDocumentCategory] = useState('');
  const [documentComments, setDocumentComments] = useState('');
  const [documentExpiryDate, setDocumentExpiryDate] = useState('');
  const [educatorData, setEducatorData] = useState(null);
  const [franchiseData, setFranchiseData] = useState(null);
  const [selectedFranchisee, setSelectedFranchisee] = useState();
  const [fileError, setFileError] = useState([]);
  const [childDocument, setChildDocument] = useState([]);
  const [uploadError, setUploadError] = useState([]);
  const [fetchedChildDocuments, setFetchedChildDocuments] = useState([]);
  const [formErrors, setFormErrors] = useState([]);
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [oldEducatorIDs, setOldEducatorIDs] = useState(null);

  const fetchFranchiseList = async () => {
    const response = await axios.get(`${BASE_URL}/role/franchisee`, AxiosHeaders);

    if (response.status === 200 && response.data.status === 'success') {
      let { franchiseeList } = response.data;
      setFranchiseData(
        franchiseeList.map((franchisee) => ({
          id: franchisee.id,
          value: franchisee.franchisee_name,
          label: franchisee.franchisee_name,
        }))
      );
    }
  };

  const fetchEducatorList = async (franchise) => {
    const response = await axios.get(
      `${BASE_URL}/user-group/users/${franchise}`, AxiosHeaders);
    if (response.status === 200 && response.data.status === 'success') {
      let { users } = response.data;
      setEducatorData(
        users.map((user) => ({
          id: user.id,
          value: user.fullname,
          label: `${user.fullname} (${user.email})`,
        }))
      );
    }
  };

  const handleChildData = (event) => {
    event.preventDefault();
    let { name, value } = event.target;
    setFormOneChildData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const initiateEnrollment = async () => {
    let formData = new FormData();
    Object?.keys(formOneChildData)?.map((item) => {
      formData?.append(item, formOneChildData?.[item]);
    });

    // SETTING FILES;
    childDocument?.forEach((item, index) => {
      formData?.append(`images`, item);
    });
    if (documentCategory) formData?.append('category', documentCategory);
    if (documentComments) formData?.append('comments', documentComments);
    if (documentExpiryDate) formData?.append('expiry_date', documentExpiryDate);

    try {
      let response = await axios.get(`${BASE_URL}/auth/user/${paramsParentId}`, AxiosHeaders);

      if (response.status === 200 && response.data.status === 'success') {
        let { user } = response.data;
        let { franchisee_id } = user;
        response = await axios.patch(`${BASE_URL}/enrollment/child/${paramsChildId}`, formData, AxiosHeaders);

        if (response.status === 201 && response.data.status === 'success') {
          let removedEducators = oldEducatorIDs.filter(
            (d) => !formOneChildData.educator.includes(d)
          );
          response = await axios.post(`${BASE_URL}/enrollment/child/assign-educators/${paramsChildId}`, { educatorIds: formOneChildData?.educator, removedEducatorIds: removedEducators, }, AxiosHeaders);
          if (response.status === 201) {
            let redirectionURL =
              payload?.from === 'user-listing'
                ? `/children/${paramsParentId}`
                : '/children-all';

            window.location.href = redirectionURL;
          }
        }
      }
    } catch (err) {
      setLoader(false);
      if (err.response?.status === 400 && err.response?.data?.msg) {
        setErrors((prev) => ({ ...prev, document_category: err.response.data.msg }));
      }
    }
  };

  const fetchAndPopulateChildData = async () => {
    let response = await axios.get(
      `${BASE_URL}/enrollment/child/${paramsChildId}?parentId=${paramsParentId}`, AxiosHeaders);

    if (response.status === 200 && (await response).data.status === 'success') {
      let { child } = response.data;

      let {
        users,
        fullname,
        family_name,
        child_files_data: fileData,
        dob,
        home_address,
        sex,
        child_crn,
        name_of_school,
        school_status,
        start_date,
        has_special_needs,
        franchisee_id,
        id,
      } = child;
      let educatorIds = users.map((d) => d.id);

      setFetchedChildDocuments(fileData);

      setFormOneChildData((prevState) => ({
        ...prevState,
        fullname,
        family_name,
        dob,
        home_address,
        sex,
        child_crn,
        name_of_school,
        school_status,
        start_date,
        has_special_needs,
        franchisee_id,
        id,
        educator: [...educatorIds],
      }));

      setOldEducatorIDs([...educatorIds]);
    }
  };

  const submitFormData = (event) => {
    event.preventDefault();

    let errorObj = enrollmentInitiationFormValidation(formOneChildData, {
      childDocument,
      documentCategory,
    });
    if (Object.keys(errorObj).length > 0) {
      setErrors(errorObj);
    } else {
      setLoader(true);
      initiateEnrollment();
    }
  };

  const initiateCancelEvent = () => {
    const url = payload?.from === 'child-listing' ? '/children-all' : `/children/${paramsParentId}`;
    window.location.href = url;
  };

  useEffect(() => {
    fetchEducatorList(formOneChildData?.franchisee_id);
  }, [formOneChildData?.franchisee_id]);

  useEffect(() => {
    fetchAndPopulateChildData();
    fetchFranchiseList();
  }, []);

  const getUniqueErrors = (arr) => {
    var result = [];
    arr.forEach(function (item) {
      if (result.indexOf(item) < 0) {
        result.push(item);
      }
    });

    return result;
  };
  const handleUserFileDelete = async (id, childId) => {
    let response = await axios.get(
      `${BASE_URL}/enrollment/child/file/delete/${childId}/${id}`, AxiosHeaders);

    let { success } = response?.data;
    if (success) {
      let tempData = fetchedChildDocuments?.filter((item) => item?.id !== id);
      setFetchedChildDocuments(tempData);
    }
  };

  return (
    <>
      <div id="main">
        <section className="mainsection">
          <Container>
            <div className="admin-wrapper">
              <aside className="app-sidebar">
                <LeftNavbar />
              </aside>
              <div className="sec-column">
                <TopHeader setSelectedFranchisee={setSelectedFranchisee} />
                {/* Issue with access and permit
                  Request to " Educators have access to edit child or guardian’s profile, please remove"
                  12/Apr/2025
                  changed by - PrashantSurya
                */}
                <div className={`entry-container ${(LSUserRole == MonaRoles.educator || LSUserRole == MonaRoles.guardian || LSUserRole == MonaRoles.parent) && !isViewOnly ? "noClick" : ""}`}>
                  <header className="title-head">
                    <h1 className="title-lg">
                      {isViewOnly ? 'Child Enrolment (View Only)' : 'Child Enrolment Initiation Form'}
                    </h1>
                  </header>
                  <div className="enrollment-form-sec error-sec my-5">
                    <Form onSubmit={submitFormData}>
                      <div className="enrollment-form-column">
                        <div className="grayback">
                          <h2 className="title-xs mb-2">
                            Basic details about the child
                          </h2>
                          <Row>
                            <Col md={6}>
                              <Form.Group className="mb-3 relative">
                                <Form.Label>Child's First Name *</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="fullname"
                                  disabled={isViewOnly || LSUserRole === 'guardian'}
                                  value={formOneChildData?.fullname || ''}
                                  onChange={(e) => {
                                    handleChildData(e);
                                    setErrors((prevState) => ({
                                      ...prevState,
                                      fullname: null,
                                    }));
                                  }}
                                />
                                {errors.fullname !== null && (
                                  <span className="error">
                                    {errors.fullname}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group className="mb-3 relative">
                                <Form.Label>Child's Family Name *</Form.Label>
                                <Form.Control
                                  type="text"
                                  minLenth={3}
                                  maxLength={50}
                                  disabled={isViewOnly || LSUserRole === 'guardian'}
                                  name="family_name"
                                  value={formOneChildData?.family_name || ''}
                                  onChange={(e) => {
                                    // if(isNaN(e.target.value.charAt(e.target.value.length - 1)) === true) {
                                    setFormOneChildData((prevState) => ({
                                      ...prevState,
                                      family_name: e.target.value,
                                    }));
                                    setErrors((prevState) => ({
                                      ...prevState,
                                      family_name: null,
                                    }));
                                  }}
                                />
                                {errors?.family_name !== null && (
                                  <span className="error">
                                    {errors?.family_name}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group className="mb-3 relative">
                                <Form.Label>Date Of Birth *</Form.Label>
                                <Form.Control
                                  type="date"
                                  name="dob"
                                  disabled={isViewOnly || LSUserRole === 'guardian'}
                                  max={new Date().toISOString().slice(0, 10)}
                                  value={formOneChildData?.dob || ''}
                                  onChange={(e) => {
                                    handleChildData(e);
                                    setErrors((prevState) => ({
                                      ...prevState,
                                      dob: null,
                                    }));
                                  }}
                                />
                                {errors.dob !== null && (
                                  <span className="error">{errors.dob}</span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group className="mb-3 relative">
                                <Form.Label>Start Date *</Form.Label>
                                <Form.Control
                                  type="date"
                                  name="start_date"
                                  disabled={isViewOnly || LSUserRole === 'guardian'}
                                  // max={new Date().toISOString().slice(0, 10)}
                                  // min={new Date().toISOString().slice(0, 10)}
                                  value={formOneChildData?.start_date || ''}
                                  onChange={(e) => {
                                    handleChildData(e);
                                    setErrors((prevState) => ({
                                      ...prevState,
                                      start_date: null,
                                    }));
                                  }}
                                />
                                {errors.start_date !== null && (
                                  <span className="error">
                                    {errors.start_date}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={12}>
                              <Form.Group className="mb-3 relative">
                                <div className="btn-radio inline-col">
                                  <Form.Label>Sex *</Form.Label>
                                  <Form.Check
                                    type="radio"
                                    name="gender"
                                    id="malecheck"
                                    label="Male"
                                    disabled={isViewOnly || LSUserRole === 'guardian'}
                                    checked={formOneChildData?.sex === 'M'}
                                    defaultChecked
                                    onChange={(event) =>
                                      setFormOneChildData((prevState) => ({
                                        ...prevState,
                                        sex: 'M',
                                      }))
                                    }
                                  />
                                  <Form.Check
                                    type="radio"
                                    name="gender"
                                    disabled={isViewOnly || LSUserRole === 'guardian'}
                                    id="femalecheck"
                                    checked={formOneChildData?.sex === 'F'}
                                    label="Female"
                                    onChange={(event) =>
                                      setFormOneChildData((prevState) => ({
                                        ...prevState,
                                        sex: 'F',
                                      }))
                                    }
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <Form.Group className="mb-3 relative">
                                <Form.Label>Home Address *</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  style={{ resize: 'none' }}
                                  disabled={isViewOnly || LSUserRole === 'guardian'}
                                  value={formOneChildData?.home_address || ''}
                                  onChange={(e) => {
                                    setFormOneChildData((prevState) => ({
                                      ...prevState,
                                      home_address: e.target.value,
                                    }));
                                    setErrors((prevState) => ({
                                      ...prevState,
                                      home_address: null,
                                    }));
                                  }}
                                />
                                {errors.home_address !== null && (
                                  <span className="error">
                                    {errors.home_address}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group className="mb-3 relative">
                                <Form.Label>Select Franchise *</Form.Label>
                                <Select
                                  placeholder={'Select'}
                                  isDisabled={isViewOnly || LSUserRole !== 'franchisor_admin'}
                                  closeMenuOnSelect={true}
                                  value={franchiseData?.filter(
                                    (d) =>
                                      parseInt(d.id) ===
                                      parseInt(formOneChildData?.franchisee_id)
                                  )}
                                  options={franchiseData}
                                  onChange={(e) => {
                                    setFormOneChildData((prevState) => ({
                                      ...prevState,
                                      franchisee_id: e.id,
                                    }));

                                    setErrors((prevState) => ({
                                      ...prevState,
                                      franchiseData: null,
                                    }));
                                  }}
                                />
                                {errors.educatorData !== null && (
                                  <span className="error">
                                    {errors.educatorData}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group className="mb-3 relative">
                                <Form.Label>Select An Educator *</Form.Label>
                                <Select
                                  placeholder={'Select'}
                                  closeMenuOnSelect={true}
                                  isMulti
                                  isDisabled={isViewOnly || LSUserRole === 'guardian'}
                                  value={educatorData?.filter((d) =>
                                    formOneChildData?.educator.includes(d.id)
                                  )}
                                  options={educatorData}
                                  onChange={(e) => {
                                    setFormOneChildData((prevState) => ({
                                      ...prevState,
                                      educator: [...e.map((e) => e.id)],
                                    }));

                                    setErrors((prevState) => ({
                                      ...prevState,
                                      educatorData: null,
                                    }));
                                  }}
                                />
                                {errors.educatorData !== null && (
                                  <span className="error">
                                    {errors.educatorData}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group className="mb-3 relative">
                                <div className="btn-radio inline-col">
                                  <Form.Label>
                                    Does your child have special needs? *
                                  </Form.Label>
                                  <Form.Check
                                    type="radio"
                                    disabled={isViewOnly || LSUserRole === 'guardian'}
                                    name="has_special_needs"
                                    id="specialneedsyes"
                                    label="Yes"
                                    checked={
                                      formOneChildData?.has_special_needs === 1
                                    }
                                    defaultChecked
                                    onChange={(event) =>
                                      setFormOneChildData((prevState) => ({
                                        ...prevState,
                                        has_special_needs: 1,
                                      }))
                                    }
                                  />
                                  <Form.Check
                                    type="radio"
                                    name="has_special_needs"
                                    disabled={isViewOnly || LSUserRole === 'guardian'}
                                    id="specialneedsno"
                                    checked={
                                      formOneChildData?.has_special_needs === 0
                                    }
                                    label="No"
                                    onChange={(event) =>
                                      setFormOneChildData((prevState) => ({
                                        ...prevState,
                                        has_special_needs: 0,
                                      }))
                                    }
                                  />
                                </div>
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group className="mb-3 relative">
                                <div className="btn-radio inline-col">
                                  <Form.Label>School Status *</Form.Label>
                                  <Form.Check
                                    type="radio"
                                    name="school_status"
                                    id="statuscheckyes"
                                    label="Yes"
                                    disabled={isViewOnly || LSUserRole === 'guardian'}
                                    checked={
                                      formOneChildData?.school_status === 'Y'
                                    }
                                    defaultChecked
                                    onChange={(event) =>
                                      setFormOneChildData((prevState) => ({
                                        ...prevState,
                                        school_status: 'Y',
                                      }))
                                    }
                                  />
                                  <Form.Check
                                    type="radio"
                                    name="school_status"
                                    id="statuscheckno"
                                    disabled={isViewOnly || LSUserRole === 'guardian'}
                                    checked={
                                      formOneChildData?.school_status === 'N'
                                    }
                                    label="No"
                                    onChange={(event) =>
                                      setFormOneChildData((prevState) => ({
                                        ...prevState,
                                        school_status: 'N',
                                      }))
                                    }
                                  />
                                </div>
                              </Form.Group>
                            </Col>

                            {formOneChildData?.school_status === 'Y' && (
                              <Col md={6}>
                                <Form.Group className="mb-3 relative">
                                  <Form.Label>School Name *</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="name_of_school"
                                    disabled={isViewOnly || LSUserRole === 'guardian'}
                                    value={
                                      formOneChildData?.name_of_school || ''
                                    }
                                    onChange={(e) => {
                                      handleChildData(e);
                                      setErrors((prevState) => ({
                                        ...prevState,
                                        name_of_school: null,
                                      }));
                                    }}
                                  />
                                  {errors.name_of_school !== null && (
                                    <span className="error">
                                      {errors.name_of_school}
                                    </span>
                                  )}
                                </Form.Group>
                              </Col>
                            )}

                            <Col md={6}>
                              <Form.Group className="mb-3 relative">
                                <Form.Label>Child CRN *</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="child_crn"
                                  disabled={isViewOnly || LSUserRole === 'guardian'}
                                  // ref={child_crn}
                                  value={formOneChildData.child_crn || ''}
                                  onChange={(e) => {
                                    handleChildData(e);
                                  }}
                                />

                                {errors?.child_crn !== null && (
                                  <span className="error">
                                    {errors?.child_crn}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={12}>
                              <Form.Group className="col-md-12 mb-3 relative">
                                <Form.Label>{isViewOnly ? 'Uploaded Documents' : 'Upload Documents'}</Form.Label>
                                {!isViewOnly && (
                                  <>
                                    <Row>
                                      <Col md={4}>
                                        <Form.Group className="mb-2">
                                          <Form.Label>Category *</Form.Label>
                                          <Form.Select
                                            value={documentCategory ?? ''}
                                            isInvalid={errors.document_category != null}
                                            onChange={(e) => {
                                              setDocumentCategory(e.target.value);
                                              setErrors((prev) => ({ ...prev, document_category: null }));
                                            }}
                                          >
                                            <option value="">Select category</option>
                                            {(CHILDREN_CATEGORIES || []).map((cat) => (
                                              <option key={cat} value={cat}>{cat}</option>
                                            ))}
                                          </Form.Select>
                                          {errors.document_category != null && (
                                            <span className="error">{errors.document_category}</span>
                                          )}
                                        </Form.Group>
                                      </Col>
                                      <Col md={4}>
                                        <Form.Group className="mb-2">
                                          <Form.Label>Expiry Date</Form.Label>
                                          <Form.Control
                                            type="date"
                                            value={documentExpiryDate ? documentExpiryDate.replace(/\//g, '-') : ''}
                                            onChange={(e) => setDocumentExpiryDate(e.target.value)}
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col md={4}>
                                        <Form.Group className="mb-2">
                                          <Form.Label>Comments</Form.Label>
                                          <Form.Control
                                            type="text"
                                            placeholder="Optional"
                                            value={documentComments || ''}
                                            onChange={(e) => setDocumentComments(e.target.value)}
                                          />
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                    <DragDropMultiple
                                      module="user-management"
                                      onSave={setChildDocument}
                                      setUploadError={setUploadError}
                                    />
                                  </>
                                )}
                                {!isViewOnly && fileError &&
                                  getUniqueErrors(fileError).map((errorObj) => {
                                    return (
                                      <p
                                        key={errorObj}
                                        style={{
                                          color: 'tomato',
                                          fontSize: '12px',
                                        }}
                                      >
                                        {errorObj === 'Too many files'
                                          ? 'Only 20 files allowed'
                                          : errorObj.includes('File type must be text/*')
                                            ? "zip file uploads aren't allowed"
                                            : errorObj}
                                      </p>
                                    );
                                  })}
                                {fetchedChildDocuments && fetchedChildDocuments.length > 0 && (
                                  <div style={{ maxHeight: '260px', overflowY: 'auto', marginTop: '10px', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                                    <table className="table table-sm table-bordered mb-0">
                                      <thead>
                                        <tr>
                                          <th>File Name</th>
                                          <th>Category</th>
                                          <th>Expiry</th>
                                          <th>Comments</th>
                                          <th>Uploaded</th>
                                          {!isViewOnly && <th>Delete</th>}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {fetchedChildDocuments.map((doc) => (
                                          <tr key={doc?.id}>
                                            <td>
                                              <a href={doc?.file} target="_blank" rel="noopener noreferrer">
                                                {doc?.name || (doc?.file && doc.file.split('/').slice(-1)[0]) || 'Document'}
                                              </a>
                                            </td>
                                            <td>{doc?.category || 'Other'}</td>
                                            <td>{doc?.expiry_date ? moment(doc.expiry_date).format('YYYY/MM/DD') : '-'}</td>
                                            <td title={doc?.comments}>{doc?.comments ? (doc.comments.length > 20 ? doc.comments.slice(0, 20) + '...' : doc.comments) : '-'}</td>
                                            <td>{doc?.createdAt ? moment(doc.createdAt).format('YYYY/MM/DD') : '-'}</td>
                                            {!isViewOnly && (
                                              <td>
                                                <img
                                                  onClick={() => handleUserFileDelete(doc?.id, formOneChildData?.id)}
                                                  style={{ width: '18px', height: 'auto', cursor: 'pointer' }}
                                                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Delete-button.svg/862px-Delete-button.svg.png"
                                                  alt="Delete"
                                                />
                                              </td>
                                            )}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                                {formErrors.doc !== null && (
                                  <span className="error">
                                    {formErrors.doc}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <div className="cta text-center mt-5 mb-5">
                        <Button
                          variant={
                            LSUserRole === 'guardian'
                              ? 'primary'
                              : 'outline'
                          }
                          onClick={() => initiateCancelEvent()}
                          className="me-3"
                        >
                          {LSUserRole === 'guardian'
                            ? 'Back'
                            : 'Cancel'}
                        </Button>
                        {LSUserRole !== 'guardian' && !isViewOnly && (
                          <Button variant="primary" type="submit">
                            {loader === true ? (
                              <>
                                <img
                                  style={{ width: '24px' }}
                                  src={'/img/mini_loader1.gif'}
                                  alt=""
                                />
                                Submitting...
                              </>
                            ) : (
                              'Submit'
                            )}
                          </Button>
                        )}
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </>
  );
};

export default EditChildEnrollmentInitiation;
